import { get, post } from './http-calls';

export const getErrorFolders = async () => {
    let res = await get(`DocumentsReprocess/ErrorFolders`, { useAuthToken: true });
    return res;
};

export const getBranches = async (errorFolder) => {
    let res = await get(`DocumentsReprocess/Branches/${errorFolder}`, { useAuthToken: true });
    return res;
};

export const getDocumentTypes = async (errorFolder, branch) => {
    let res = await get(`DocumentsReprocess/DocumentTypes/${errorFolder}/${branch}`, { useAuthToken: true });
    return res;
};

export const getFiles = async (errorFolder, branch, documentType) => {
    let res = await get(`DocumentsReprocess/Files/${errorFolder}/${branch}/${documentType}`, { useAuthToken: true });
    return res;
};

export const processDocument = async (data) => {
    let res = await post(`DocumentsReprocess/ReProcessFiles`, data, { useAuthToken: true });
    return res;
};
// Streams the document back as a blob so the grid can preview it inline.
export const postDocumentsReprocessViewDocument = async (data) => {
    let res = await post(`DocumentsReprocess/ViewDocument`, data, {
        responseType: 'blob',
        returnOrgRes: true,
        useAuthToken: true
    });
    return window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf; charset=utf-8' }));
};

// Bulk delete: DeleteDocumentsVM { errorFolder, branchName, documentType, locations[] }
export const deleteDocuments = async (data) => {
    let res = await post(`DocumentsReprocess/DeleteDocuments`, data, { useAuthToken: true });
    return res;
};
